import { EMPTY_OBJECT } from '../../../../constants/common'

export const RENTAL_PORTAL_LIST_RESOURCE = {
  applicants: 'applicants',
  listings: 'listings',
  viewings: 'viewings',
}

export const RENTAL_PORTAL_LIST_PERMISSIONS_REQUEST = {
  filters: EMPTY_OBJECT,
  pagination: { page: 1, per_page: 1 },
}
